import axios from "axios";
//
// eslint-disable-next-line import/named
import { LOCALE_LANG } from "../../i18n/config.locale";

let baseUrl;

let locale = LOCALE_LANG.LOCALE_DEFAULT;

if (process.env.NODE_ENV === "production") {
  baseUrl = process.env.REACT_APP_API_NODE;
  // Disable the console log in production.
  // eslint-disable-next-line no-console
} else {
  baseUrl = process.env.REACT_APP_API_NODE;
}
// console.log("baseUrl", baseUrl);

const lxtFsUrl = process.env.REACT_APP_LXT_FS_NODE;
export const hsnaFsUrl = process.env.REACT_APP_HSNA_FS_NODE;
// 協助寄送 mail 的 api
const managerApi = process.env.REACT_APP_MANAGER_API_DOMAIN;

const fetchApi = process.env.REACT_APP_WEB_FETCH_API;

const defaultApis = {
  locale_lang: LOCALE_LANG,
  getLocale: () => locale,
  setLocale(lang) {
    locale = lang;
  },
  getAxios: () => axios,
  setAxiosAuth(token) {
    // 不加 prefix "Bearer "
    axios.defaults.headers.Authorization = `${token}`;
    axios.defaults.headers.common.Authorization = `${token}`;
  },
  // abcd
  getDownloadTemplate: () => `${baseUrl}/download/template/{pattern}`,

  // efgh
  getExportReadFileSna: () =>
    `${lxtFsUrl}/export/readFile/hsna_sna?filename={filename}`,
  getExportReadFileGis: () =>
    `${lxtFsUrl}/export/readFile/hsna_gis&filename={filename}`,
  // e
  getEventTypes: () =>
    `${baseUrl}/hsna/eventTypes/1.0?limit=-1&offset=0&graph={graph}`,

  // ijkl
  postSingleImportFile: () => `${lxtFsUrl}/import/file/{pattern}`,

  // mnop

  // qrst
  getSettingPrivacy: () =>
    `${baseUrl}/hsna/setting/privacy/1.0?limit=-1&offset=0`,
  getSettingTermsOfService: () =>
    `${baseUrl}/hsna/setting/termsOfService/1.0?limit=-1&offset=0`,
  // 取得日誌的基本資料(diary及相關人物,事件tag...)
  getSnaDatasetPublic: () =>
    `${baseUrl}/hsna/sna/dataset/public/1.1?limit={limit}&offset={offset}&graph={graph}&startDate={startDate}&endDate={endDate}`,
  // 取得日誌的詳細資訊(日誌內文)
  getSnaDatasetPublicDetail: () =>
    `${baseUrl}/hsna/sna/dataset/public/detail/1.1?limit={limit}&offset={offset}&ids={ids}&graph={graph}&inKinship={inKinship}`,

  // AJi
  getGptAnswerUrl: process.env.REACT_APP_GET_GPT_ANS_URL,
  postRateToDbUrl: process.env.REACT_APP_POST_RATE_TO_DB_URL,

  // uvwx
  uploadOcrFile: `${hsnaFsUrl}/hsna/uploadOCRfile`,
  checkOcrFile: `${hsnaFsUrl}/hsna/checkPDFcut`,
  getOcrImgList: `${baseUrl}/ocr/${locale}/hsna/ocr/upload/image/list/1.0?limit={limit}&offset={offset}&filename={filename}&userId={userId}`,

  generateOcrResult: `${hsnaFsUrl}/hsna/DoingOCR`,
  checkOcrResult: `${hsnaFsUrl}/hsna/checkOCRinDB`,
  updateOcrData: `${baseUrl}/ocr/${locale}/generic/2.0`,

  // yz

  /* mail */
  postMail: () => `${managerApi}/mail`,

  /* user */
  postCheckEmailExist: () => `${managerApi}/checkEmailExist`,
  postUpdateUserGroup: () => `${managerApi}/updateUserGroup`,
  postDeleteUserGroup: () => `${managerApi}/deleteUserGroup`,
  postCheckUserInGroup: () => `${managerApi}/checkUserInGroup`,

  /* API Ftech */
  getAIAnalyze: () => `${fetchApi}/AISemantic`,
  getAICheck: () => `${fetchApi}/check`,
};

// For feature control
const FEATURE_STORE_LIST = { stardog: 1, fuseki: 2 };
// 1, 2
const FEATURE_STORE = 2;

const fusekiApis = {
  // for fuseki
  // 取得日誌的基本資料(diary及相關人物,事件tag...)
  getSnaDatasetPublic: () =>
    `${baseUrl}/hsna/sna/dataset/public/2.0?limit={limit}&offset={offset}&graph={graph}&startDate={startDate}&endDate={endDate}`,
};

export default {
  ...defaultApis,
  // society network with kinship
  // getSocietyNetworkKinship 2.0版為 => 親屬關係為主, 社團為輔

  ...(FEATURE_STORE === FEATURE_STORE_LIST.fuseki ? fusekiApis : {}),
};
